/**
 * Goal of this class is to move all communication between react, backbone, php
 * into one single event bus.
 */
// Todo: Move stripe <-> React communication here

const internalprefixEventName = 'InternalEventBus_';

export const prefixEventName = (eventName: string) => {
  return `${internalprefixEventName}${eventName}`;
};

class InternalEventBus {
  // eslint-disable-next-line @typescript-eslint/ban-types
  internalStoreListeners: { [eventName: string]: Function[] };

  private static instance: InternalEventBus;

  static getInstance() {
    if (!InternalEventBus.instance) {
      InternalEventBus.instance = new InternalEventBus();
    }
    return InternalEventBus.instance;
  }

  private constructor() {
    this.internalStoreListeners = {};
  }

  /**
   * Get a callback when we have a event.
   * @param event.eventName === Name of the event you want to listen
   * @param event.callbackFn === Name of the function to call.
   */
  // Todo: Verify if the event is actually a Global event/ or from some whitelist
  listen = ({
    eventName,
    callbackFn,
  }: {
    eventName: string;
    callbackFn: (data?: any) => unknown;
  }): void => {
    const prefixedEventName = prefixEventName(eventName);

    if (this.internalStoreListeners[prefixedEventName]) {
      if (!this.internalStoreListeners[prefixedEventName].includes(callbackFn)) {
        this.internalStoreListeners[prefixedEventName].push(callbackFn);
      }
    } else {
      this.internalStoreListeners[prefixedEventName] = [callbackFn];
    }
  };

  /**
   * Tell everyone there has been an event
   * @param eventName === Name of the event you want to listen
   * @param event.data === Data you want to pass to the other side
   */
  // Todo: Verify if the event is actually a Global event/ or from some whitelist
  emit = (eventName: string, { data = null }: { data?: any | null } = {}): void => {
    const prefixedEventName = prefixEventName(eventName);
    const listOfCallbacks = this.internalStoreListeners[prefixedEventName];
    if (listOfCallbacks) {
      const copyEvent = [...listOfCallbacks];
      // Not sure why the order changes after the function is called
      copyEvent.forEach(callbackFn => {
        callbackFn(data);
      });
    }
  };

  /**
   * Destroy all internalStoreListeners
   */
  destroy = () => {
    this.internalStoreListeners = {};
  };

  /**
   * remove listener with event name
   * @param eventName Name of event to remove
   * @param callbackFn Name of callBack which originally subscribed to the function
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  unSubscribe = (eventName: string, callbackFn: Function): void => {
    const prefixedEventName = prefixEventName(eventName);

    if (this.internalStoreListeners[prefixedEventName]) {
      const indexOfCallback = this.internalStoreListeners[prefixedEventName].findIndex(
        _callbackFn => _callbackFn === callbackFn
      );
      this.internalStoreListeners[prefixedEventName].length > 1
        ? this.internalStoreListeners[prefixedEventName].splice(indexOfCallback, 1)
        : delete this.internalStoreListeners[prefixedEventName];
    }
  };
}

export const Eventbus = InternalEventBus.getInstance();
